<template>
  <f7-page name="addReferral" class="modern-ui" @page:init="initPage" @page:reinit="initPage">
    <bc-navbar :showLogo="true" :logoSrc="rafLogo"></bc-navbar>
    <div class="page-container">
      <referral-program-banner :referralProgramId="referralProgramType" />

      <div class="card elevated referral-from">
        <div class="referral-from-header">
          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.9836 0C7.15586 0 0 7.15586 0 15.9836C0 24.8114 7.15586 31.9672 15.9836 31.9672C24.8114 31.9672 31.9672 24.8114 31.9672 15.9836C31.9672 7.15586 24.8114 0 15.9836 0ZM10.3893 11.9877C10.3893 11.2531 10.534 10.5256 10.8152 9.84687C11.0963 9.16815 11.5084 8.55144 12.0279 8.03196C12.5473 7.51249 13.164 7.10042 13.8428 6.81928C14.5215 6.53814 15.249 6.39344 15.9836 6.39344C16.7183 6.39344 17.4457 6.53814 18.1244 6.81928C18.8032 7.10042 19.4199 7.51249 19.9393 8.03196C20.4588 8.55144 20.8709 9.16815 21.152 9.84687C21.4332 10.5256 21.5779 11.2531 21.5779 11.9877C21.5779 13.4714 20.9885 14.8943 19.9393 15.9434C18.8902 16.9926 17.4673 17.582 15.9836 17.582C14.4999 17.582 13.077 16.9926 12.0279 15.9434C10.9787 14.8943 10.3893 13.4714 10.3893 11.9877ZM25.9861 23.9498C24.7893 25.4545 23.2681 26.6694 21.5362 27.5041C19.8043 28.3388 17.9062 28.7717 15.9836 28.7705C14.061 28.7717 12.163 28.3388 10.431 27.5041C8.69907 26.6694 7.17793 25.4545 5.98107 23.9498C8.57201 22.0909 12.1076 20.7787 15.9836 20.7787C19.8596 20.7787 23.3952 22.0909 25.9861 23.9498Z"
                fill="currentColor" />
            </svg>
          </div>
          <h3 class="title">Text one friend</h3>
          <p class="description">Add their info and we’ll create a personalized message you can send in just a tap</p>
          <div class="badge">Best for one friend</div>
        </div>

        <div class="form-group">
          <div class="form-control">
            <input v-model="formData.firstName" data-vv-name="firstName" data-vv-as="First Name" v-validate="'required'"
              type="text" placeholder="First Name">
            <span v-if="errors.first('firstName')" class="error-message">
              {{ errors.first('firstName') }}
            </span>
          </div>

          <div class="form-control">
            <input v-model="formData.lastName" data-vv-name="lastName" data-vv-as="Last Name" v-validate="'required'"
              type="text" placeholder="Last Name">
            <span v-if="errors.first('lastName')" class="error-message">
              {{ errors.first('lastName') }}
            </span>
          </div>
          <div class="form-control">
            <vue-tel-input data-vv-name="Phone" v-model="formData.phone" :phone="formData.phone"
              v-validate.continues="{ phone: true }" :invalid="invalidPhone" :showOverlay="false"
              placeholder="Phone number (optional)"></vue-tel-input>
            <span v-if="invalidPhone" class="error-message">
              {{ errors.first("Phone") }}
            </span>
          </div>
        </div>

        <div class="info-card">
          <div class="icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M8 9H16M8 13H14M18 4C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H13L8 21V18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>

          <p>Adding a number lets us open a ready-to-send text automatically. Skip it and you can use the share menu
            on
            the next screen</p>
        </div>

        <button class="mui-button accent ripple" :disabled="!canContinue" @click="onSave()">
          <send-icon/>
          Continue to message preview
        </button>
      </div>

      <button @click="onShareToFb()" :disabled="loading" type="button" class="card card-button">
        <div class="icon">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
              d="M32 16.0401C32 7.18596 24.832 0 16 0C7.168 0 0 7.18596 0 16.0401C0 23.8035 5.504 30.2677 12.8 31.7594V20.8521H9.6V16.0401H12.8V12.0301C12.8 8.93434 15.312 6.41604 18.4 6.41604H22.4V11.2281H19.2C18.32 11.2281 17.6 11.9499 17.6 12.8321V16.0401H22.4V20.8521H17.6V32C25.68 31.198 32 24.3649 32 16.0401Z"
              fill="currentColor" />
          </svg>
        </div>
        <div class="title">Facebook Share</div>
        <div class="text">Post to your feed and reach your entire network with one tap. </div>
        <div class="chevron">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M12 8L20 16L12 24" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </button>

      <f7-link :href="referralHistoryUrl" class="mui-button w-100 stroked accent">
        <external-link-icon/>
        Open history
      </f7-link>

      <div class="card options">
        <div class="title">Which option should I use?</div>
        <div class="option">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M12.0026 2C12.7098 2 13.3881 2.28095 13.8882 2.78105C14.3883 3.28115 14.6693 3.95942 14.6693 4.66667V10C14.6693 10.7072 14.3883 11.3855 13.8882 11.8856C13.3881 12.3857 12.7098 12.6667 12.0026 12.6667H10.2786L8.47394 14.4713C8.35914 14.5861 8.20641 14.6551 8.04439 14.6653C7.88237 14.6754 7.72221 14.6262 7.59394 14.5267L7.53127 14.4713L5.72594 12.6667H4.0026C3.31844 12.6667 2.66045 12.4037 2.16473 11.9322C1.66901 11.4607 1.37348 10.8166 1.33927 10.1333L1.33594 10V4.66667C1.33594 3.95942 1.61689 3.28115 2.11699 2.78105C2.61708 2.28095 3.29536 2 4.0026 2H12.0026ZM9.33594 8H5.33594C5.15913 8 4.98956 8.07024 4.86453 8.19526C4.73951 8.32029 4.66927 8.48986 4.66927 8.66667C4.66927 8.84348 4.73951 9.01305 4.86453 9.13807C4.98956 9.2631 5.15913 9.33333 5.33594 9.33333H9.33594C9.51275 9.33333 9.68232 9.2631 9.80734 9.13807C9.93237 9.01305 10.0026 8.84348 10.0026 8.66667C10.0026 8.48986 9.93237 8.32029 9.80734 8.19526C9.68232 8.07024 9.51275 8 9.33594 8ZM10.6693 5.33333H5.33594C5.15913 5.33333 4.98956 5.40357 4.86453 5.5286C4.73951 5.65362 4.66927 5.82319 4.66927 6C4.66927 6.17681 4.73951 6.34638 4.86453 6.4714C4.98956 6.59643 5.15913 6.66667 5.33594 6.66667H10.6693C10.8461 6.66667 11.0157 6.59643 11.1407 6.4714C11.2657 6.34638 11.3359 6.17681 11.3359 6C11.3359 5.82319 11.2657 5.65362 11.1407 5.5286C11.0157 5.40357 10.8461 5.33333 10.6693 5.33333Z"
              fill="currentColor" />
          </svg>
          <div class="title">Text one friend</div>
          <p class="text">Perfect for referring a friend directly. They'll get a personal message from you.</p>
        </div>
        <div class="option">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M5.33594 2.6644C4.62869 2.6644 3.95042 2.94535 3.45032 3.44545C2.95022 3.94554 2.66927 4.62382 2.66927 5.33106C2.66927 6.03831 2.95022 6.71659 3.45032 7.21668C3.95042 7.71678 4.62869 7.99773 5.33594 7.99773C6.04318 7.99773 6.72146 7.71678 7.22156 7.21668C7.72165 6.71659 8.0026 6.03831 8.0026 5.33106C8.0026 4.62382 7.72165 3.94554 7.22156 3.44545C6.72146 2.94535 6.04318 2.6644 5.33594 2.6644ZM4.0026 8.6644C3.29536 8.6644 2.61708 8.94535 2.11699 9.44545C1.61689 9.94554 1.33594 10.6238 1.33594 11.3311V11.9977C1.33594 12.3514 1.47641 12.6905 1.72646 12.9405C1.97651 13.1906 2.31565 13.3311 2.66927 13.3311H8.0026C8.35623 13.3311 8.69536 13.1906 8.94541 12.9405C9.19546 12.6905 9.33594 12.3514 9.33594 11.9977V11.3311C9.33594 10.6238 9.05499 9.94554 8.55489 9.44545C8.05479 8.94535 7.37651 8.6644 6.66927 8.6644H4.0026ZM8.83594 7.26773C9.1546 6.6944 9.33594 6.0344 9.33594 5.33106C9.33608 4.65336 9.16403 3.98672 8.83594 3.39373C9.21448 3.03555 9.68968 2.79614 10.2028 2.70508C10.7159 2.61403 11.2445 2.67532 11.7232 2.88139C12.2018 3.08745 12.6096 3.42926 12.8962 3.86456C13.1827 4.29987 13.3354 4.80959 13.3354 5.33073C13.3354 5.85187 13.1827 6.36159 12.8962 6.7969C12.6096 7.2322 12.2018 7.57401 11.7232 7.78007C11.2445 7.98614 10.7159 8.04743 10.2028 7.95638C9.68968 7.86532 9.21448 7.62591 8.83594 7.26773ZM10.3133 13.3311C10.5399 12.9391 10.6699 12.4837 10.6699 11.9977V11.3311C10.6712 10.3469 10.3083 9.39708 9.65127 8.6644H12.0026C12.7098 8.6644 13.3881 8.94535 13.8882 9.44545C14.3883 9.94554 14.6693 10.6238 14.6693 11.3311V11.9977C14.6693 12.3514 14.5288 12.6905 14.2787 12.9405C14.0287 13.1906 13.6896 13.3311 13.3359 13.3311H10.3133Z"
              fill="currentColor" />
          </svg>
          <div class="title">Share to Facebook</div>
          <p class="text">Great for a wider audience. More eyes, more chances to help someone you know.</p>
        </div>
        <div class="option">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2 6.94727C2 4.81527 2 3.74927 2.252 3.3906C2.50333 3.0326 3.50533 2.68927 5.51 2.00327L5.892 1.8726C6.93667 1.5146 7.45867 1.33594 8 1.33594C8.54133 1.33594 9.06333 1.5146 10.108 1.8726L10.49 2.00327C12.4947 2.68927 13.4967 3.0326 13.748 3.3906C14 3.74927 14 4.81594 14 6.94727V7.9966C14 11.7553 11.174 13.5799 9.40067 14.3539C8.92 14.5639 8.68 14.6693 8 14.6693C7.32 14.6693 7.08 14.5639 6.59933 14.3539C4.826 13.5793 2 11.7559 2 7.9966V6.94727ZM9.33333 6.0026C9.33333 6.35623 9.19286 6.69536 8.94281 6.94541C8.69276 7.19546 8.35362 7.33594 8 7.33594C7.64638 7.33594 7.30724 7.19546 7.05719 6.94541C6.80714 6.69536 6.66667 6.35623 6.66667 6.0026C6.66667 5.64898 6.80714 5.30984 7.05719 5.05979C7.30724 4.80975 7.64638 4.66927 8 4.66927C8.35362 4.66927 8.69276 4.80975 8.94281 5.05979C9.19286 5.30984 9.33333 5.64898 9.33333 6.0026ZM8 11.3359C10.6667 11.3359 10.6667 10.7393 10.6667 10.0026C10.6667 9.26594 9.47333 8.66927 8 8.66927C6.52667 8.66927 5.33333 9.26594 5.33333 10.0026C5.33333 10.7393 5.33333 11.3359 8 11.3359Z"
              fill="currentColor" />
          </svg>
          <div class="title">Your message includes your personal link so you get credit when they visit and buy.</div>
        </div>
      </div>

      <loader v-if="loading" :show="true"/>
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { PAGES } from '../../shared/routes.constants'
import { notify } from '@/shared/notifications.js'
import { ReferralShareType } from '../../shared/enums/referral.enum'
import ExternalLinkIcon from '@components/icons/external-link.icon.vue'
import SendIcon from '@components/icons/send.icon.vue'
import Loader from '@components/loader.vue'
import ReferralProgramBanner from '@components/referral/referral-program-banner.vue'
export default {
  components: {
    loader: Loader,
    ExternalLinkIcon,
    SendIcon,
    ReferralProgramBanner
  },
  computed: {
    ...mapGetters({
      sharedLinkData: 'recommendFriend/sharedLinkData',
      referralProgramType: 'recommendFriend/referralProgramType',
      referralData: 'recommendFriend/getNewReferrlaData'
    }),
    invalidPhone () {
      return this.errors.first('Phone')
    },
    canContinue () {
      return !Object.values(this.fields).some(field => field.invalid)
    }
  },
  methods: {
    ...mapActions({
      setNewReferral: 'recommendFriend/setNewReferralData',
      resetNewReferral: 'recommendFriend/clearNewReferralData',
      getSharedLink: 'recommendFriend/getShareLink',
      getSharedLinkWithCode: 'recommendFriend/getShareLinkWithCode',
      sendSharedLink: 'recommendFriend/sendSharedLink',
      addReferral: 'recommendFriend/addReferral',
      getReferral: 'recommendFriend/getReferral',
      editReferral: 'recommendFriend/editReferral'
    }),
    initPage () {
      if (this.referralData) {
        this.editReferralHistoryId = this.referralData.referralHistoryId
        const {firstName, lastName, phone} = this.referralData
        this.formData.firstName = firstName
        this.formData.lastName = lastName
        this.formData.phone = phone
      } else {
        this.editReferralHistoryId = null
        this.resetForm()
      }
      this.resetNewReferral()
    },
    async onSave () {
      const valid = await this.$validator.validate()
      if (!valid) return
      this.editReferralHistoryId ? this.edit() : this.add()
    },
    async goToPreview (code, contactId, referralHistoryId) {
      const linkData = await this.getSharedLinkWithCode(code)
      if (!linkData || !linkData.link) {
        this.loading = false
        notify.error('Error. Could not get referral link.')
        return
      }
      this.setNewReferral({...this.formData, code, link: linkData.link, contactId, referralHistoryId})
      this.resetForm()
      this.loading = false
      this.$router.load({ url: PAGES.RecommendAFriendMessagePreview })
    },
    async edit () {
      this.loading = true
      const referralHistoryId = this.editReferralHistoryId
      const referralDataRes = await this.getReferral({ referralHistoryId })
      if (!referralDataRes || !referralDataRes.success || !referralDataRes.model) {
        this.loading = false
        notify.error('Error during edit referral')
        return
      }
      const {firstName, lastName, phone} = this.formData
      const editResult = await this.editReferral({
        referralHistoryId,
        fullName: `${firstName} ${lastName}`,
        phone,
        commentText: referralDataRes.model.commentText
      })
      if (!editResult || !editResult.success) {
        this.loading = false
        notify.error('Error during edit referral')
        return
      }
      const {code, referralContactId: contactId} = referralDataRes.model
      await this.goToPreview(code, contactId, referralHistoryId)
    },
    async add () {
      this.loading = true
      const {firstName, lastName, phone} = this.formData
      const addResult = await this.addReferral({
        refferals: [{firstName, lastName, phone}]
      })
      if (!addResult || !addResult.success || !addResult.model || !addResult.model.length) {
        this.loading = false
        notify.error('Error. Referral was not added.')
        return
      }
      const {referralCode: code, contactId, referralHistoryId} = addResult.model[0]
      if (!code) {
        this.loading = false
        notify.error('Error. Referral was not added.')
        return
      }
      await this.goToPreview(code, contactId, referralHistoryId)
    },
    async onShareToFb () {
      if (!this.sharedLinkData.link) {
        this.loading = true
        await this.getSharedLink()
        this.loading = false
      }
      const { link, title } = this.sharedLinkData
      this.share(link, title, () =>
        this.onShareResult(ReferralShareType.Facebook),
      )
    },
    share (link, title, fn) {
      try {
        navigator
          .share({
            url: link,
            title: title
          })
          .then(() => fn())
      } catch (err) {
        notify.error('Error during share proccess')
      }
    },
    onShareResult (type) {
      this.loading = true
      this.sendSharedLink()
        .then(() => {
          if (type !== 'individual') {
            return
          }
          this.$router.load({
            url: `/${PAGES.RecommendAFriendReferral}`
          })
        })
        .catch(() => notify.error('Error during share proccess'))
        .finally(() => (this.loading = false))
    },
    resetForm () {
      this.formData.firstName = null
      this.formData.lastName = null
      this.formData.phone = null
      this.$validator.reset()
    }
  },
  data () {
    return {
      loading: false,
      rafLogo: require('@/assets/raf-logo-lg.png'),
      formData: {
        firstName: null,
        lastName: null,
        phone: null
      },
      referralHistoryUrl: PAGES.RecommendAFriendHistory,
      editReferralHistoryId: null
    }
  }
}
</script>

<style scoped lang="scss">

.page-container {
  padding-inline: 18px;
  padding-block: 8px 16px;
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;

  >*+* {
    margin-top: 24px;
  }

  .page-title {
    text-align: left;

    >.title {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      padding: 0;
    }

    >.subtitle {
      font-size: 14px;
      color: #354C78;
      font-weight: 500;
    }
  }
}

.banner {
  width: 100%;
  max-width: 355px;
  margin-inline: auto;
}

.referral-from {
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  .referral-from-header {
    display: grid;
    grid-template-columns: 50px 1fr auto;
    column-gap: 8px;
    grid-auto-flow: dense;
    align-items: start;


    .icon {
      width: 100%;
      max-width: 50px;
      color: #033BAA;
      background-color: #E6EFFD;

      grid-row: span 2;
      align-self: center;
    }


    .title {
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      padding: 0;
    }

    .description {
      font-weight: 500;
      font-size: 13px;
      margin: 0;
      line-height: 1.2;

      grid-column: 2 / span 2;
    }

    .badge {
      font-size: 10px;
      border-radius: 24px;
      color: #1CB995;
      background-color: #F4FDFB;
      border: 1px solid #E3F6F4;
      align-self: center;
    }
  }

  .form-group {
    display: grid;
    row-gap: 8px;
  }

}

.info-card {
  display: grid;
  grid-template-columns: 42px 1fr;
  align-items: center;
  column-gap: 10px;
  row-gap: 4px;

  p {
    margin: 0;
    line-height: 1.2;
  }

  :has(.title){
    .icon{
      grid-row: span 2;
    }
  }

  .icon {
    width: 42px;
  }
}

.card-button {
  display: grid;
  grid-template-columns: 50px 1fr 32px;
  grid-auto-flow: column;
  column-gap: 8px;
  align-items: center;
  border: 1px solid #ECEEF2;
  text-align: initial;
  box-shadow: none;

  .icon {
    background-color: #E6EFFD;
    color: #033BAA;
  }

  :first-child,
  :last-child {
    grid-row: span 2;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #060732;
  }

  .text {
    line-height: 1.2;
    color: #354C78;
  }

  .chevron {
    display: grid;
    place-content: center;
    color: #354C78;
  }
}

.options {
  $col-gap: 12px;

  display: flex;
  flex-wrap: wrap;
  background-color: #F3F7FC;
  column-gap: $col-gap;
  padding: 12px 16px;

  >.title {
    flex: 1 1 100%;
    font-size: 16;
    font-weight: 600;
    margin-bottom: 28px;
    text-align: center;
  }

  >:last-child {
    flex: 1 1 100%;

    display: flex;
    column-gap: 4px;
    align-items: start;

    svg {
      flex-shrink: 0;
    }
  }

  .option {
    box-sizing: border-box;

    svg {
      color: #033BAA;
    }

    flex: 1 1 calc(50% - #{$col-gap});

    >.title {
      font-weight: 600;
      font-size: 14px;
      line-height: 1.2;
    }

    p {
      margin: 0;
      line-height: 1.2;
    }

    &:nth-of-type(-n + 2) {
      border-right: 1px solid #ccc;
      padding-right: $col-gap;
    }

    &:has(+*) {
      margin-bottom: 16px;
    }
  }
}

.text-center {
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// add-referral.vue?86476d7c